import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useBreakpoint from 'hooks/useBreakpoint';
import { getDynamicImage } from 'helpers/ImageHelper';
import { isMobileBreakpoint } from 'helpers/BreakpointHelper';
import style from './Avatar.module.scss';

const Avatar = ({ alt, img, centeredImg, theme, title, context, unoptimized, isSeries }) => {
  const breakpoint = useBreakpoint();
  if (!img) return null;
  const image = getDynamicImage({
    breakpoint,
    url: isSeries && isMobileBreakpoint(breakpoint) ? centeredImg : img,
    context,
    unoptimized,
  });
  return (
    <div className={classNames(style.avatarContainer, theme.avatarContainer)}>
      <img className={classNames(style.avatar, theme.avatar)} src={image} alt={alt} />;
    </div>
  );
};

Avatar.propTypes = {
  alt: PropTypes.string,
  context: PropTypes.string,
  img: PropTypes.string,
  isSeries: PropTypes.bool,
  centeredImg: PropTypes.string,
  theme: PropTypes.shape({}).isRequired,
  title: PropTypes.string,
  unoptimized: PropTypes.bool,
};

export default Avatar;
